function waitForDrawerAndInit() {
  var observer = new MutationObserver(function(mutations, obs) {
    if (document.querySelector('.flyer-addon')) {
      obs.disconnect();
      initFlyerAddon();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  // Fallback nach 2s
  setTimeout(function() { observer.disconnect(); }, 2000);
}

function initFlyerAddon() {
  $(document).off('click.flyer');
  $(document).off('input.flyer');

  var pendingQty = null;

  $(document).on('input.flyer', '.flyer-quantity', function() {
    pendingQty = parseInt(this.value, 10);
  });

  $(document).on('click.flyer', '.flyer-plus', function(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
    var $input = $('.flyer-quantity');
    var newVal = Math.min(99, parseInt($input.val()) + 1);
    $input.val(newVal);
    pendingQty = newVal;
    return false;
  });

  $(document).on('click.flyer', '.flyer-minus', function(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
    var $input = $('.flyer-quantity');
    var newVal = Math.max(0, parseInt($input.val()) - 1);
    $input.val(newVal);
    pendingQty = newVal;
    return false;
  });

  $(document).on('click.flyer', '.flyer-submit', function(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    var qty = pendingQty !== null ? pendingQty : parseInt(document.querySelector('.flyer-quantity').value, 10);
    var variantId = parseInt(document.querySelector('.flyer-id').value, 10);
    var itemKey = document.querySelector('.flyer-key').value;

    if (isNaN(qty) || qty < 0) qty = 0;
    if (qty > 99) qty = 99;

    pendingQty = null;

    var ajaxUrl = itemKey ? '/cart/change.js' : '/cart/add.js';
    var ajaxData = itemKey
      ? { id: itemKey, quantity: qty }
      : { id: variantId, quantity: qty };

    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: JSON.stringify(ajaxData),
      contentType: 'application/json',
      dataType: 'json',
      success: function() {
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
          waitForDrawerAndInit();
        } else {
          window.location.reload();
        }
      },
      error: function(xhr) {
        console.log('Flyer error:', xhr.responseText);
      }
    });

    return false;
  });
}

$(document).ready(function() {
  initFlyerAddon();
});
